module.exports = __webpack_public_path__ + "img/9788960513136.3e851f1c.jpg";